export default "__VITE_ASSET__cae5fee8__"